import { render } from "./TfaContainer.vue?vue&type=template&id=d05a4c5a"
import script from "./TfaContainer.vue?vue&type=script&lang=js"
export * from "./TfaContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__